import React from 'react';

function PositionRadioButton(props){
   
    return (
        <div>
            <div className="custom-control custom-radio">
                    <input type="radio" id="customRadio1" name="customRadioAuto" className="custom-control-input" value="0" checked={ props.isAuto ===0 } onChange={props.handleIsAuto.bind(this)}/>
                    <label className="custom-control-label" htmlFor="customRadio1">自選職缺(資料無連動主網，主網刪除職缺時，中繼頁職缺需另刪除)</label>
            </div>
            <div className="custom-control custom-radio">
                <input type="radio" id="customRadio2" name="customRadioAuto" className="custom-control-input" value="1" checked={  props.isAuto===1 } onChange={props.handleIsAuto.bind(this)}/>
                <label className="custom-control-label" htmlFor="customRadio2">{`自動抓最新${props.limitCount}筆職缺`}</label>
            </div>
        </div>      
    )
}


export default PositionRadioButton;